"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeHead = void 0;
const fp_1 = require("lodash/fp");
const monet_1 = require("monet");
const { None, fromNull } = monet_1.Maybe;
/**
 * [a] -> Maybe a
 *
 * Returns the first item in an array
 * @example
 * safeHead([ 1 ]) // => Just(1)
 * @example
 * safeHead([]) // => None
 * @example
 * safeHead() // => None
 */
function safeHead(array) {
    return Array.isArray(array)
        ? fromNull((0, fp_1.head)(array))
        : None();
}
exports.safeHead = safeHead;
//# sourceMappingURL=safeHead.js.map